/* CENIT · Recomendaciones cruzadas entre anillos, collares y pulseras.
   · [data-cs]  → carril "Completa tu set" (producto, carrito lateral, página de carrito)
   · [data-cmb] → bloque compacto "Completa tu set" junto al botón de compra
   Escucha 'cenit:cart-updated' (lo emiten el header, la ficha de producto y cenit-card.js). */
(function () {
  if (window.cenitCrossSellReady) return;
  window.cenitCrossSellReady = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  var KINDS = ['anillo', 'collar', 'pulsera'];
  var ONE = { anillo: 'un anillo', collar: 'un collar', pulsera: 'una pulsera' };
  var LABEL = { anillo: 'TU ANILLO', collar: 'TU COLLAR', pulsera: 'TU PULSERA' };
  var lastCart = null;
  var map = null;

  /* ---------- Tipo de cada pieza del carrito ---------- */
  function kindMap() {
    if (map) return map;
    map = {};
    var el = document.getElementById('CenitKinds');
    if (el) {
      try {
        var data = JSON.parse(el.textContent);
        for (var id in data) map[id] = data[id];
      } catch (e) {}
    }
    document.querySelectorAll('[data-pid][data-kind]').forEach(function (n) {
      if (!map[n.getAttribute('data-pid')]) map[n.getAttribute('data-pid')] = n.getAttribute('data-kind');
    });
    return map;
  }

  function kindOf(item) {
    var k = kindMap()[String(item.product_id)];
    if (k) return k;
    var t = (item.product_type || '').toLowerCase();
    if (/pulsera|bracelet/.test(t)) return 'pulsera';
    if (/collar|necklace/.test(t)) return 'collar';
    return 'anillo';
  }

  window.cenitKindOf = kindOf;
  window.cenitKindLabel = function (item) { return LABEL[kindOf(item)] || 'TU ESTRELLA'; };

  function joinO(list) {
    if (list.length < 2) return list.join('');
    return list.slice(0, -1).join(', ') + ' o ' + list[list.length - 1];
  }

  function shuffleChildren(parent, selector) {
    var items = Array.prototype.slice.call(parent.querySelectorAll(selector));
    for (var i = items.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = items[i]; items[i] = items[j]; items[j] = t;
    }
    items.forEach(function (el) { parent.appendChild(el); });
    return items;
  }

  function inCartSet(cart) {
    var set = {};
    if (cart && cart.items) cart.items.forEach(function (it) { set[String(it.product_id)] = true; });
    return set;
  }

  /* ---------- Carril "Completa tu set" ---------- */
  function setupRail(cs) {
    if (cs._cs) return cs._cs;
    var rail = cs.querySelector('[data-cs-rail]');
    if (!rail) return null;
    var items = shuffleChildren(rail, '[data-cs-item]');
    var tabs = Array.prototype.slice.call(cs.querySelectorAll('[data-cs-tab]'));
    var titleEl = cs.querySelector('[data-cs-title]');
    var subEl = cs.querySelector('[data-cs-sub]');
    var state = {
      mode: cs.getAttribute('data-cs-mode') || 'cart',
      active: null,
      allowed: tabs.map(function (t) { return t.getAttribute('data-cs-tab'); }),
      inCart: {}
    };

    function available(kind) {
      return items.filter(function (it) {
        return it.getAttribute('data-kind') === kind && !state.inCart[it.getAttribute('data-pid')];
      });
    }

    function render() {
      var usable = state.allowed.filter(function (k) { return available(k).length > 0; });
      if (!usable.length) { cs.hidden = true; return; }
      cs.hidden = false;
      if (usable.indexOf(state.active) === -1) state.active = usable[0];

      tabs.forEach(function (t) {
        var k = t.getAttribute('data-cs-tab');
        t.hidden = usable.indexOf(k) === -1;
        var on = k === state.active;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.classList.toggle('is-active', on);
        t.tabIndex = on ? 0 : -1;
      });
      cs.classList.toggle('cx--single-tab', usable.length < 2);

      items.forEach(function (it) {
        it.hidden = !(it.getAttribute('data-kind') === state.active && !state.inCart[it.getAttribute('data-pid')]);
      });
      rail.scrollLeft = 0;
      rail.dispatchEvent(new Event('scroll'));
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        state.active = t.getAttribute('data-cs-tab');
        render();
      });
      t.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var visible = tabs.filter(function (x) { return !x.hidden; });
        var idx = visible.indexOf(t) + (e.key === 'ArrowRight' ? 1 : -1);
        var next = visible[(idx + visible.length) % visible.length];
        if (next) { next.focus(); next.click(); }
      });
    });

    function update(cart) {
      state.inCart = inCartSet(cart);
      if (state.mode === 'cart' && cart) {
        var present = {};
        cart.items.forEach(function (it) { present[kindOf(it)] = true; });
        var missing = KINDS.filter(function (k) { return !present[k]; });
        if (!cart.item_count) {
          state.allowed = KINDS.slice();
          if (titleEl) titleEl.textContent = 'Empieza tu set';
          if (subEl) subEl.textContent = 'Anillos, collares y pulseras de plata .925.';
        } else if (missing.length) {
          state.allowed = missing;
          if (titleEl) titleEl.textContent = 'Completa tu set';
          if (subEl) subEl.textContent = 'Suma ' + joinO(missing.map(function (k) { return ONE[k]; })) + ' a tu pedido.';
        } else {
          state.allowed = KINDS.slice();
          if (titleEl) titleEl.textContent = 'También te puede gustar';
          if (subEl) subEl.textContent = '';
        }
        if (subEl) subEl.hidden = !subEl.textContent;
      }
      render();
    }

    if (subEl) subEl.hidden = !subEl.textContent.trim();
    cs._cs = { update: update };
    render();
    return cs._cs;
  }

  /* ---------- Bloque compacto junto al botón de compra ---------- */
  function money(cents) {
    var n = Math.round(cents) / 100;
    return '$' + n.toLocaleString('es-MX', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }) + ' MXN';
  }

  function setupCombo(box) {
    if (box._cmb) return box._cmb;
    var minis = Array.prototype.slice.call(box.querySelectorAll('[data-cs-mini]'));
    var byKind = {};
    minis.forEach(function (m) {
      var k = m.getAttribute('data-kind');
      (byKind[k] = byKind[k] || []).push(m);
    });
    Object.keys(byKind).forEach(function (k) {
      var arr = byKind[k];
      for (var i = arr.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = arr[i]; arr[i] = arr[j]; arr[j] = t;
      }
    });
    var pos = {};
    var inCart = {};
    var threshold = parseInt(box.getAttribute('data-threshold'), 10) || 0;

    function base() { return parseInt(box.getAttribute('data-base'), 10) || 0; }

    function note(m) {
      var el = m.querySelector('[data-cs-note]');
      if (!el) return;
      var total = base() + (parseInt(m.getAttribute('data-price'), 10) || 0);
      var cartTotal = lastCart ? lastCart.total_price : 0;
      var show = threshold > 0 && cartTotal < threshold && base() < threshold && total >= threshold;
      el.hidden = !show;
      el.textContent = show ? 'Juntos llegan a ' + money(total) + ': envío gratis' : '';
    }

    function show() {
      var any = false;
      Object.keys(byKind).forEach(function (k) {
        var arr = byKind[k].filter(function (m) { return !inCart[m.getAttribute('data-pid')]; });
        byKind[k].forEach(function (m) { m.hidden = true; });
        if (!arr.length) return;
        var i = (pos[k] || 0) % arr.length;
        arr[i].hidden = false;
        note(arr[i]);
        any = true;
      });
      box.hidden = !any;
    }

    var shuffleBtn = box.querySelector('[data-cmb-shuffle]');
    if (shuffleBtn) {
      shuffleBtn.addEventListener('click', function () {
        Object.keys(byKind).forEach(function (k) { pos[k] = (pos[k] || 0) + 1; });
        show();
        box.classList.remove('is-swapping');
        void box.offsetWidth;
        box.classList.add('is-swapping');
      });
    }

    box.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-cs-size]');
      if (!sel) return;
      var btn = sel.parentNode.querySelector('.cx-mini__add');
      if (!btn) return;
      if (sel.value) {
        btn.setAttribute('data-cc-variant', sel.value);
        btn.disabled = false;
      } else {
        btn.removeAttribute('data-cc-variant');
        btn.disabled = true;
      }
    });

    /* La ficha de producto cambia de precio al cambiar de variante */
    document.addEventListener('cenit:variant-change', function (e) {
      if (e.detail && e.detail.price != null) { box.setAttribute('data-base', e.detail.price); show(); }
    });

    box._cmb = {
      update: function (cart, initial) {
        if (initial) inCart = inCartSet(cart);
        show();
      }
    };
    show();
    return box._cmb;
  }

  /* ---------- Arranque ---------- */
  function all(scope) {
    var list = [];
    (scope || document).querySelectorAll('[data-cs]').forEach(function (cs) { var c = setupRail(cs); if (c) list.push(c); });
    (scope || document).querySelectorAll('[data-cmb]').forEach(function (b) { list.push(setupCombo(b)); });
    return list;
  }

  function refresh(cart, initial) {
    lastCart = cart;
    all().forEach(function (c) { c.update(cart, initial); });
  }

  function start() {
    all();
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { refresh(cart, true); })
      .catch(function () {});
  }

  document.addEventListener('cenit:cart-updated', function (e) {
    if (!e.detail || !e.detail.cart) return;
    var cart = e.detail.cart;
    /* Espera a que la tarjeta muestre la palomita antes de reacomodar el carril */
    clearTimeout(refresh._t);
    refresh._t = setTimeout(function () { refresh(cart, false); }, 950);
  });
  document.addEventListener('shopify:section:load', function (e) {
    all(e.target).forEach(function (c) { c.update(lastCart, true); });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
